import React from "react";
import { Form } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import _ from "lodash";

class CommentForm extends React.Component {
  state = {
    username: this.props.username,
    content: "",
    error: false,
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = (e) => {
    const { username, content } = this.state;
    if (_.isEmpty(username)) {
      if (!_.isNull(this.props.popUpFunctionName)) {
        this.setState({ error: true });
        window.parent.postMessage(
          {
            func: this.props.popUpFunctionName,
            message: "open_name_popup",
          },
          "*"
        );
      }
    } else if (_.isEmpty(content)) {
      this.setState({ error: true });
    } else {
      this.props.addComment(username, content);
      this.setState({ content: "", error: false });
    }
  };

  render() {
    const { t } = this.props;
    const { content, error } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Group>
          <Form.Input
            autoComplete="off"
            error={error}
            className="comment-field"
            placeholder={t("chat_connect_placeholder")}
            name="content"
            value={content}
            onChange={this.handleChange}
          />
          <Form.Button
            circular
            className="comment-send-button"
            icon="send"
            size="mini"
          />
        </Form.Group>
      </Form>
    );
  }
}

export default withTranslation()(CommentForm);
